export const MAX_CLIENT_ERROR_URL_LENGTH = 1024;
export const CLIENT_ERROR_DEDUPE_MS = 30_000;

// Where a Log_ClientErrors row came from (stored in ExtraData.source)
export type ClientErrorSource = 'api' | 'boundary' | 'window' | 'promise';

// Browser noise that carries no actionable detail
const IGNORED_CLIENT_ERRORS = [
    /ResizeObserver loop/i,
    /^(Message: )?Script error\.?$/i,
];

export function truncateClientErrorUrl(url: string): string {
    return url.slice(0, MAX_CLIENT_ERROR_URL_LENGTH);
}

// Same text layout BlockingErrorMessage uses for Log_ClientErrors.ErrorText
export function formatClientErrorText(error: unknown): string {
    if (!(error instanceof Error)) {
        return `Message: ${String(error)}`;
    }

    let errorText = `Name: ${error.name}\nMessage: ${error.message}\n\n`;
    if (error.stack) {
        errorText += `Stack Trace:\n${error.stack}`;
    }
    return errorText;
}

export function isIgnoredClientError(errorText: string): boolean {
    return IGNORED_CLIENT_ERRORS.some(pattern => pattern.test(errorText.trim()));
}

/**
 * Returns false when the same error was already logged within the dedupe window,
 * so a render loop or retry storm can't flood Log_ClientErrors.
 */
export function shouldLogClientError(key: string, lastLogged: Map<string, number>, now = Date.now()): boolean {
    const previous = lastLogged.get(key);
    if (previous !== undefined && now - previous < CLIENT_ERROR_DEDUPE_MS) {
        return false;
    }

    lastLogged.set(key, now);
    // Keep the map from growing without bound on long-lived tabs
    if (lastLogged.size > 200) {
        for (const [entryKey, time] of lastLogged) {
            if (now - time >= CLIENT_ERROR_DEDUPE_MS) lastLogged.delete(entryKey);
        }
    }
    return true;
}
